module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("d74qt"))).then(() => module.bundle.root('ljYL6'));